import { render, staticRenderFns } from "./VideoRoomWidget.vue?vue&type=template&id=4f991bb6"
import script from "./VideoRoomWidget.vue?vue&type=script&lang=js"
export * from "./VideoRoomWidget.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomWidget.vue?vue&type=style&index=0&id=4f991bb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports